import { EChartOption } from 'echarts'
import { FC, useEffect, useMemo, useState } from 'react'
import en from 'src/constants/en'
import { EChart } from 'src/charts/EChart'
import { CampaignChartDataItem } from './interfaces/campaignChartDataItem.interface'
import styles from './campaignsChart.module.scss'

interface CampaignsChartProps {
  negativeMentionsCount: number
  neutralMentionsCount: number
  positiveMentionsCount: number
  size?: number
}

export const CampaignsChart: FC<CampaignsChartProps> = ({
  negativeMentionsCount,
  neutralMentionsCount,
  positiveMentionsCount,
  size = 122,
}) => {
  const [chartData, setChartData] = useState<CampaignChartDataItem[]>([])
  const [label, setLabel] = useState<number>()

  const total =
    negativeMentionsCount + neutralMentionsCount + positiveMentionsCount

  const maxRatioPercent = total
    ? Math.max(
        (positiveMentionsCount / total) * 100,
        (negativeMentionsCount / total) * 100,
        (neutralMentionsCount / total) * 100
      )
    : 0

  const options: EChartOption<EChartOption.SeriesPie> = useMemo(() => {
    const options: EChartOption<EChartOption.SeriesPie> = {
      color: ['#8080FF', '#FF6833', '#C7CED1'],
      grid: {
        left: 'center',
      },
      series: [
        {
          avoidLabelOverlap: true,
          data: chartData,
          emphasis: {
            // @ts-ignore-next-line
            scale: false,
          },
          height: size,
          itemStyle: {
            borderColor: '#FFFFFF',
            borderWidth: 1,
          },
          label: {
            show: false,
          },
          labelLine: {
            show: false,
          },
          left: 'center',
          radius: ['68%', '90%'],
          top: 'middle',

          type: 'pie',
          width: size,
        },
      ],
      tooltip: {
        formatter: '{b}: {c}',
        trigger: 'item',
      },
    }

    return options
  }, [chartData])

  useEffect(() => {
    setChartData([
      { name: en.positive, value: positiveMentionsCount },
      { name: en.negative, value: negativeMentionsCount },
      { name: en.neutral, value: neutralMentionsCount },
    ])

    setLabel(maxRatioPercent)
  }, [negativeMentionsCount, neutralMentionsCount, positiveMentionsCount])

  return options ? (
    <div
      className={styles.campaignsChart}
      style={{ height: size, width: size }}
    >
      <div className={styles.label} style={{ fontSize: 20, fontWeight: 500 }}>
        {label?.toFixed(0)}%
      </div>

      <EChart
        onMouseOut={() => setLabel(maxRatioPercent)}
        onMouseOver={(event) => setLabel(event.percent)}
        options={options}
      />
    </div>
  ) : null
}
